import { IDEA_STATUSES } from '@cult/domain';
import type { IdeaStatus } from '@cult/schemas';
import { Flex, Input, Modal, Typography } from 'antd';
import { NOTE_REQUIRED_FOR, STATUS_ACTION_LABEL } from '../../hooks/use-idea-transition';

const { Text } = Typography;

type Props = {
  target: IdeaStatus | null;
  note: string;
  onNoteChange: (value: string) => void;
  onOk: () => void;
  onCancel: () => void;
  confirmLoading: boolean;
};

export const TransitionConfirmModal = ({ target, note, onNoteChange, onOk, onCancel, confirmLoading }: Props) => {
  const noteRequired = target !== null && NOTE_REQUIRED_FOR.includes(target);

  return (
    <Modal
      open={target !== null}
      title={target ? `Confirm: ${STATUS_ACTION_LABEL[target]}` : ''}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText={target ? STATUS_ACTION_LABEL[target] : 'Confirm'}
      okButtonProps={{
        danger: target === IDEA_STATUSES.REJECTED,
        disabled: noteRequired && !note.trim(),
      }}
    >
      <Flex vertical gap={8}>
        <Text type="secondary">
          {noteRequired
            ? 'Add a short decision note. The author will see it on their idea.'
            : 'Optional note for the audit log.'}
        </Text>
        <Input.TextArea
          rows={4}
          value={note}
          onChange={(e) => onNoteChange(e.target.value)}
          maxLength={2000}
          showCount
          placeholder={noteRequired ? 'Why is this idea being rejected?' : 'Why is this happening? (optional)'}
          style={{ marginBottom: 22 }}
        />
      </Flex>
    </Modal>
  );
};
